import axios from './axiosInstance';


const setDefaults=() => {
    axios.defaults.headers.common['Content-Type']='application/x-www-form-urlencode';
    axios.defaults.headers.common['Accept']='application/json';
};

const GetCart=({user, device}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.post(`/cart/getcart`, {user, device})
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const AddToCart=({_id,  item}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.post(`/cart/add`,{_id,  ...item})
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const EmptyCart=({_id}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.patch(`/cart/empty/${_id}`,)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}


const IncreaseCartCount=({_id,itemId,amount}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.patch(`/cart/increase/`, { _id, itemId, amount})
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}


const DecreaseCartCount=({_id, itemId, amount}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.patch(`/cart/decrease/`, { _id, itemId, amount})
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const MergeCart=({token,user, device,  cart_id}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/cart/merge`,{user, device, cart_id})
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const RepeatOrder=({cartId, orderId}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.post(`/cart/repeat/`, {cartId, orderId})
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}



export {
    GetCart,
    AddToCart,
    EmptyCart,
    IncreaseCartCount,
    DecreaseCartCount,
    MergeCart,
    RepeatOrder
}



